import { IBookFromPreviousOrder, IBookStrategy } from '@aca-new/app/pages/book/shared/models/interfaces/book-strategy.interface';
import { IDraft } from '@aca-new/app/pages/book/shared/models/interfaces/draft.interface';
import { BookFromPreviousOrderService } from '@aca-new/app/pages/bookings/pages/previous-order-item/components/book-from-previous-order/shared/services/book-from-previous-order/book-from-previous-order.service';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { EPostMessageType } from '@aca-new/app/shared/models/enums/post-message-type.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { AppOverlayService } from '@aca-new/app/shared/services/modal-services/app-overlay/app-overlay.service';
import { AcaMessageService } from '@aca-new/app/shared/services/post-message-services/aca-message/aca-message.service';
import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class FoodCertificationBookStrategyService implements IBookStrategy {
  public constructor(
    private readonly _injector: Injector,
    private readonly _router: Router,
    private readonly _overlayService: AppOverlayService,
    private readonly _bookFromPreviousOrderService: BookFromPreviousOrderService,
    private readonly _appUserSettingService: AppUserSettingService
  ) {}

  public getBookFromPreviousUrl(orderId: string, serviceType: string): string {
    return `${SERVER_URL}/v1.0/food-certification/recertify?from-order-id=${orderId}&service-type=${serviceType}`;
  }

  public bookFromPreviousOrder(data: IBookFromPreviousOrder): void {
    const { serviceTypeText } = data.previousOrder.originData;
    const serviceType = serviceTypeText.toLowerCase();
    const isGGAPServiceType = serviceType === EServiceType.GGAP.toLowerCase();
    const isNewGGAPOpen = isGGAPServiceType && this._appUserSettingService.getIsGgapOrderEnabled();

    if (!isGGAPServiceType || isNewGGAPOpen) {
      this._overlayService.updateIsLoading(true);
      this._bookFromPreviousOrderService
        .createDraftFromPreviousOrder$(this.getBookFromPreviousUrl(data.previousOrder.originData.orderId, serviceType))
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (response: IDraft | null): void => {
            if (!response) {
              return;
            }

            const url = `/book-food-certification/${serviceType}/${response.draftId}?isRenewCert=true`;

            void this._router.navigateByUrl('/', { skipLocationChange: true }).then((canLeave: boolean): void => {
              if (canLeave) {
                void this._router.navigateByUrl(url);
              }
            });
            data.dialogRef?.close();
          },
          complete: (): void => {
            this._overlayService.updateIsLoading(false);
          },
        });
    } else {
      this._injector.get(AcaMessageService).postMessageToAca({
        type: EPostMessageType.BOOK_FROM_PREVIOUS_ORDER,
        data: { value: data.previousOrder.originData, serviceType: EServiceType.GGAP },
      });
    }
  }
}
